<script>
import TwModal from '@/components/generic/modal/tw-modal.vue'
import modalCascadeMixin from '@/mixins/modalCascadeMixin.js'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
export default {
  name: 'ImageCropModal',
  components: { TwLoadingSpinner, TwModal, Cropper },
  mixins: [modalCascadeMixin],
  props: {
    upload: {
      type: Object,
      required: true
    },
    debug: {
      type: Boolean,
      default: false
    }
  },
  emits: ['cropped'],
  data() {
    return {
      LoadingUploadingCroppedImage: false,
      ImageDataBlob: null,
      ImageDataUrl: null
    }
  },
  methods: {
    crop() {
      const { coordinates, canvas, } = this.$refs.cropper.getResult();
      this.ImageDataUrl = canvas.toDataURL()
      canvas.toBlob((blob) => {
        this.ImageDataBlob = blob
      })
    },
    async uploadToServer() {
      try {
        this.ValidationErrorMessage = null
        this.LoadingUploadingCroppedImage = true
        const formData = new FormData()
        formData.append('image_data', this.ImageDataBlob, 'cropped-' + this.upload.filename)
        const { data } = await axios.post(`/api/v1/uploads/${this.upload.id}/crop-image`, formData, {
          headers: {
            'Content-Type': `multipart/form-data`
          }
        })
        this.$refs.modal.close()
        this.$emit('cropped', data)
        this.LoadingUploadingCroppedImage = false
      } catch (e) {
        console.error(e)
        this.LoadingUploadingCroppedImage = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
}
</script>

<template>
  <tw-modal ref="modal" size="full" :loading="LoadingUploadingCroppedImage" @ok="uploadToServer">
    <tw-loading-spinner v-if="LoadingUploadingCroppedImage" />
    <div v-show="!LoadingUploadingCroppedImage" class="cropper">
      <cropper ref="cropper" :src="upload.url" @change="crop" />
    </div>
    <div v-if="debug">
      <img v-if="ImageDataUrl" :src="ImageDataUrl">
    </div>
  </tw-modal>
</template>

<style scoped>
.cropper {
  height: 600px;
  background: #DDD;
}
</style>
